import * as React from "react";
import { InputNumberProps } from "antd";
import { ifDef } from "src/common/ifDef";
import { InputNumberStd } from "src/components/InputNumberStd";

export type PropsEntityInputNumber = Omit<
  InputNumberProps,
  "onChange" | "value"
> & {
  value?: string[] | null;
  onChange?(value?: string[] | null): void;
};

export const EntityInputNumber: React.FC<PropsEntityInputNumber> = (props) => {
  const { value, onChange, ...restProps } = props;
  return (
    <InputNumberStd
      {...restProps}
      value={ifDef(value?.[0], (it) => +it)}
      onChange={(v) => onChange?.(ifDef(v, (it) => [String(it)]) ?? [])}
      maxLength={14}
    />
  );
};
